import request from '@/utils/request';
//优惠券列表
export function getCpList(values) {
  return request('/coupon/queryPage', {
    method: 'POST',
    data: values,
  });
}
//优惠券列表
export function getSearchCpList(values) {
  return request('/coupon/queryAllList', {
    method: 'POST',
    data: values,
  });
}
export function getUnlimited(values) {
  return request('/coupon/queryUnlimited', {
    method: 'POST',
    data: values,
  });
}
